// extracted by mini-css-extract-plugin
export var closed = "_h8-1";
export var resizer = "_h8-0";